import type { ReactNode } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

interface SiteLayoutProps {
  children: ReactNode;
  /** when true, content starts below the fixed transparent header (used on non-hero pages) */
  hasTopPadding?: boolean;
}

export default function SiteLayout({
  children,
  hasTopPadding = true,
}: SiteLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className={`flex-1 ${hasTopPadding ? "pt-16 md:pt-[72px]" : ""}`}>
        {children}
      </main>
      <SiteFooter />
    </div>
  );
}